/* global gettext */
import 'echarts/build/echarts-all.js';
import {
  Measure
} from '../../common/measure';

class eventRiverController {
  constructor($scope,
    $element,
    $timeout,
    RouterService,
    LayoutService,
    rx,
  ) {
    this.$scope = $scope;
    this.$element = $element;
    this.$timeout = $timeout;
    this.router = RouterService;
    this.LayoutService = LayoutService;
    // this.LayoutService.drilldownMax = 2;
    this.getMeasure = Measure.getMeasure;
    this.container = null;
    this.hasData = false;
    this.chart = null;
    this.chartAreaIsStacked = true;
    this.minHeight = 1;
    this.minWidth = 1;
    this.renderDebounce = 100;
    this.drill1Limit = 20;
    this.drill2Limit = 30;
    this.aggregate = null;
    this.filter = null;
    this.timeRange = 200;
    this.other = gettext('Другое');


    const subscriptions = [
      rx.Observable.merge(
        $scope.$eventToObservable('resizeBeforePrint'),
        rx.Observable.merge(
          $scope.$eventToObservable('afterPrint'),
          $scope.$eventToObservable('dashboardResize'),
          $scope.$eventToObservable('resize'),
          $scope.$eventToObservable('splitter1Changed'),
        ).debounce(this.renderDebounce),
      )
      .subscribe((e) => this.resize(e)),
      rx.Observable.merge(
        // $scope.$eventToObservable('beforePrint'),
        rx.Observable.merge(
          $scope.$toObservable('$ctrl.filter.orders'),
          $scope.$toObservable('$ctrl.filter.orderDirs'),
          $scope.$toObservable('$ctrl.aggregate'),
        ).debounce(this.renderDebounce),
      )
      .subscribe((e) => this.render(e)),
    ];

    $scope.$on('$destroy', () => {
      subscriptions.forEach((subscription) => {
        subscription.dispose();
      });
      delete this.chart;
      // this.LayoutService.drilldownMax = 0;
    });
    // $timeout(() => {});

    // $scope.$on('$init', () => {
    //   // this.$element.height(500);
    //   this.render('$init');
    // });
  }

  get isPrint() {
    return this.router.pdf || this.LayoutService.isPrint;
  }

  resize(e) {
    if (this.chart && this.$element.height() > this.minHeight &&
      this.$element.width() > this.minWidth) {
      this.chart.resize();
    }
  }

  get isTimeMeasure() {
    return this.filterData.filter.measure === 'activity_time_sum' ||
      this.filterData.filter.measure === 'call_duration_sum';
  }

  limitTo40(s) {
    return s.length > 40 ? s.substring(0, 40) + '...' : s;
  }

  goToDimEvents(cut) {
    this.router.drilldownFilter2(cut);
  }

  // эта приблуда нужна для qtWeb
  parseNewDate(dStr) {
    if (typeof dStr.getMonth === 'function') return dStr;
    // new Date('2019-06-02T23:59:59.999')
    const [dt, t] = dStr.split('T');
    let [y, m, d] = dt.split('-');
    y = parseInt(y, 0);
    m = parseInt(m, 0) - 1;
    d = parseInt(d, 0);
    let [h, min, s] = t.split(':');
    h = parseInt(h, 0);
    min = parseInt(min, 0);
    s = parseInt(s, 0);
    const date = new Date(y, m, d, h, min, s);
    return date;
  }

  updateOptions(options) {
    // console.log(this.filterData.filterData.cells);
    // console.log(this.filterData.filterData.cells.map(cell => cell['agent_application.app_name']).sort());

    this.hasData = false;
    // const dFrom = (new Date(this.router.CurrentFilterService.timeFrom));
    const dFrom = (this.parseNewDate(this.router.CurrentFilterService.timeFrom));
    const tFrom = dFrom.getTime();
    // const dTo = (new Date(this.router.CurrentFilterService.timeTo));
    const dTo = (this.parseNewDate(this.router.CurrentFilterService.timeTo));
    const tTo = dTo.getTime();

    const getFormatedDate = date => `${date.getFullYear()}-${pad2(date.getMonth()+1)}-${pad2(date.getDate())} ${
        pad2(date.getHours())}:00`;

    const timeStep = Math.floor((tTo - tFrom) / this.timeRange);
    const pad2 = (n) => `${(n < 10 ? '0' : '')}${n}`;
    const getDate = cell => {
      const hour = cell['agent_time.hour'] ? cell['agent_time.hour'] : 0;
      const d = (new Date(cell['agent_time.year'], cell['agent_time.month'] - 1,
        cell['agent_time.day'], hour)).getTime();

      const stepsQty = Math.floor((d - tFrom) / timeStep);

      let time = tFrom + timeStep * stepsQty + timeStep / 2;
      if (time > tTo) time = tTo;
      // return time;
      const date = new Date(time);
      return getFormatedDate(date);
    };

    const getValue = cell => {
      if (this.isTimeMeasure) return cell[this.filterData.filter.measure];
      return cell.record_count;
    };

    const sortIndexMeasure = this.filter.orders.indexOf('measure');
    // if (sortIndexMeasure === -1)  sortIndexMeasure = 9999;

    // collecting all data
    let data = this.filterData.filter.drilldown.map(drill => {
      const drillLabel = this.model.getDrillLabel(drill);

      const sortIndexDimension = this.filter.orders.indexOf(this.model.getDrillAttr(drill));
      let order = 'measure_asc';
      if ((sortIndexDimension !== -1 && sortIndexMeasure !== -1 && sortIndexDimension < sortIndexMeasure) ||
        (sortIndexDimension !== -1 && sortIndexMeasure === -1))
        order = `dimension_${this.filter.orderDirs[sortIndexDimension]}`;
      else if (sortIndexMeasure !== -1)
        order = `measure_${this.filter.orderDirs[sortIndexMeasure]}`;
      else order = 'measure_desc';

      // console.log(this.filterData.filterData.cells.map(cell => this.model.getCellLabel(drill, cell)).sort());
      let currentDate = null;
      return this.filterData.filterData.cells.reduce((dt, cell, i) => {
        // const xFilter = this.model.getCellFilter(drill, cell);
        const value = getValue(cell);
        if (value) {
          const kDr = this.model.getCellLabel(drill, cell);
          dt.name = drillLabel;
          dt.value += value;
          dt.order = order;
          if (!(kDr in dt.data)) {
            dt.data[kDr] = {
              cut: this.model.getCellFilter(drill, cell),
              value: value,
              data: {}
            };
          } else dt.data[kDr].value += value;

          const date = getDate(cell);
          if (!currentDate) currentDate = date;
          else if (currentDate != date) this.hasData = true;
          if (!(date in dt.data[kDr].data)) dt.data[kDr].data[date] = value;
          else dt.data[kDr].data[date] += value;
        }
        return dt;
      }, {
        value: 0,
        data: {}
      });
    });

    //  move small data value to "this.other"
    data = data.map(drill => ({
      name: drill.name,
      order: drill.order,
      value: drill.value,
      data: Object.keys(drill.data).reduce((dt, dim) => {
        if (drill.data[dim].value / drill.value < 0.005) {
          if (this.other in dt) {
            dt[this.other].value += drill.data[dim].value;
            Object.keys(drill.data[dim].data).map(time => {
              if (time in dt[this.other].data) dt[this.other].data[time] += drill.data[dim].data[time];
              else dt[this.other].data[time] = drill.data[dim].data[time];
            });
          } else {
            dt[this.other] = {
              value: drill.data[dim].value,
              data: drill.data[dim].data
            };
          }
        } else {
          dt[dim] = drill.data[dim];
        }
        return dt;
      }, {})
    }));

    const sortPredicate = (order, data) => {
      const sortPredicates = {
        measure_asc: (a, b) => data[a].value - data[b].value,
        measure_desc: (a, b) => data[b].value - data[a].value,
        dimension_asc: (a, b) => b < a ? 1 : -1,
        dimension_desc: (a, b) => b > a ? 1 : -1,
      };

      return sortPredicates[order];
    };
    // create options
    options.legend.data = [];


    options.series = data.map((ser, index) => {
      const dataLength = Object.keys(ser.data).length;
      options.legend.data.push(ser.name);
      return {
        type: 'eventRiver',
        name: ser.name,
        index: index,
        itemStyle: {
          normal: {
            label: {
              textStyle: {
                color: 'gray',
              },
            },
          },
          emphasis: {
            label: {
              textStyle: {
                color: '#555',
              },
            },
          },
        },
        data: Object.keys(ser.data).sort(sortPredicate(ser.order, ser.data))
          // .slice(0, 10)
          .map((dim, index) => ({
            name: ser.data[dim].value ? dim : '',
            index: index,
            weight: (dataLength - index) * (dataLength - index),
            cut: ser.data[dim].cut,
            dimValue: ser.data[dim].value,
            tooltip: {
              show: true, //!(dim === this.other),
            },
            evolution: Object.keys(ser.data[dim].data)
              .sort((a, b) => b <= a ? 1 : -1)
              .map(time => ({
                // time: new Date(+time),
                time: time,
                value: ser.data[dim].data[time],
                // detail: {
                //   text: ser.data[dim].data[time] ? `${dim} - ${ser.data[dim].data[time]}` : '',
                // }
              }))
          }))
      };
    });
  }

  render(e) {
    if (!this.aggregate || !this.filter ||
      !this.filterData.filterData.cells.length) {
      return;
    }

    if (this.$element.height() <= this.minHeight ||
      this.$element.width() <= this.minWidth) {
      return;
    }

    this.container = this.$element[0];

    //-------------------------------------------
    const options = {
      // animation: false,
      animation: !this.isPrint,
      // animation: e.name !== 'beforePrint' && e.name !== 'resizeBeforePrint',
      title: {
        text: '',
        subtext: ''
      },
      tooltip: {
        show: !this.isPrint,
        trigger: 'item',
        enterable: true,
        showDelay: 50,
        hideDelay: 1000,
        transitionDuration: 20,
        backgroundColor: '#ddd',
        textStyle: {
          color: '#555'
        },
        formatter: (params, ticket, callback) => {
          const tag = params.name === this.other ? 'div' : 'a';
          const id = `id_${params.series.index}_${params.data.index}`;
          const valueText = this.isTimeMeasure ? this.getMeasure(params.value.dimValue, this.filter.measure) :
            params.value.dimValue + ' ' + gettext('событий');
          const res = `<${tag} id="${id}" >${params.name} : ${valueText}</${tag}>`;
          if (params.name === this.other) return res;
          this.$timeout(() => {
            callback(ticket, res);
            this.$timeout(() => {
              $(`#${id}`).click(() => {
                this.goToDimEvents(params.data.cut);
                // return false;
              });
            }, 200);
          }, 10);
          return 'loading';
        }
      },
      legend: {
        data: ['Событие 1', 'Событие 2']
      },
      toolbox: {
        show: !this.isPrint,
        feature: {
          mark: {
            show: false
          },
          restore: {
            show: false
          },
          saveAsImage: {
            show: true,
            title: gettext('Сохранить как изображение'),
            lang: [gettext('Сохранить как изображение')],
          }
        }
      },
      xAxis: [{
        type: 'time',
        // boundaryGap: [0.05, 0.05]
      }],
      series: []
    };

    this.updateOptions(options);
    if (this.hasData) {
      this.chart = echarts.init(this.container);
      this.chart.setOption(options);
    }
    // this.chart.resize();
  }
}

export const EventRiverComponent = {
  template: require('./event-river.component.html'),
  bindings: {
    model: '<',
    aggregate: '<',
    filter: '<',
    filterData: '<',
  },

  controller: eventRiverController,
};



// WEBPACK FOOTER //
// ./src/stat/event-river/event-river.component.js